import GoogleAnalytics from 'analyticsProviders/googleAnalyticsProvider';
import Mixpanel from '../analyticsProviders/mixpanelProvider';

// A map of tracking services
const services = {
  google: GoogleAnalytics,
  mixpanel: Mixpanel
};
const initialize = () => {
  Object.values(services).forEach((service) => {
    try {
      service?.initialize();
    } catch (err) {
      console.log(
        'Failed to initialize tracking service:',
        service?.constructor?.name || 'Unknown',
        err
      );
    }
  });
};

const trackPageView = (page) => {
  Object.values(services).forEach((service) => {
    try {
      service?.trackPageView(page);
    } catch (err) {
      console.log('Failed to track page view:', err);
    }
  });
};

const trackEvent = (eventName, params) => {
  Object.values(services).forEach((service) => {
    try {
      service?.trackEvent(eventName, params);
    } catch (err) {
      console.log('Failed to track event:', eventName, err);
    }
  });
};

const identifyUser = (userId) => {
  Object.values(services).forEach((service) => {
    try {
      service?.identifyUser(userId);
    } catch (err) {
      console.log('Failed to identify user:', userId, err);
    }
  });
};
export default {
  initialize,
  trackPageView,
  trackEvent,
  identifyUser
};
